import React, { useRef, useEffect, useState, useLayoutEffect } from "react";
import lock from "../../../assets/logos/icons-lock.png";
import unlock from "../../../assets/logos/icons-unlock.png";
import p5 from "p5";
import { useTranslation } from "react-i18next";

let validation = { activeOnSubit: false };
let deleteButton = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/botebasura.svg"
let padlockLocked = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_locked.svg"
let padlickUnlocket = "https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/sign/padlock_unlocked.svg"

export default function P5ContainerCoordinates({
    tFunction,
    widthImg,
    heightImg,
    base64Img,
    imgSignature,
    widthImgSignature,
    heightImgSignature,
    save,
    saveAndReload,
    saveCoordinates,
    activeOnSubit,
    back,
    isAndroid,
    gotToEnd,
    isPhone,
    signatures,
    currentPage,
    email,
    deleteSign

}) {
    if (activeOnSubit !== validation.activeOnSubit) {
        validation.activeOnSubit = activeOnSubit;
    }
    const { t } = useTranslation();

    const p5Ref = useRef();
    const [p5Canvas, setp5Canvas] = useState(null);
    const Sketch = (sketch) => {
        let page = null;
        let isSubmit = false;
        let cancelBtn;
        let signBtn;
        let deleteBtnText;
        let locateBtnText;
        let deleteLocket
        let deletesignBtn;
        let xRect = widthImg * 0.50;
        let yRect = heightImg * 0.50;
        let wRect = 206;
        let hRect = 100;
        let signature = null
        let overImage = false;
        let locked = false;
        let xOffSet = 0;
        let yOffSet = 0;
        let done = false;
        let lockImg = null;
        let unlockImg = null;
        let isLock = false;
        let savePostion = {};
        sketch.preload = () => {
            page = sketch.loadImage(base64Img);
            signature = sketch.loadImage(imgSignature);
            lockImg = sketch.loadImage(lock);
            unlockImg = sketch.loadImage(unlock);
        };

        function setLineDash(list) {
            sketch.drawingContext.setLineDash(list);
        }

        sketch.setup = () => {
            sketch.createCanvas(widthImg, heightImg + 70);
            sketch.textSize(15);
            sketch.noStroke();
            if (signatures) {
                for (let i = 0; i < signatures.length; i++) {
                    const item = signatures[i];
                    if (item.page === currentPage && item.email === email) {
                        deleteLocket = sketch.createImg(padlockLocked);
                        deletesignBtn = sketch.createImg(deleteButton);
                        deleteBtnText = sketch.createButton(tFunction("signatureRequestProfile.dialogLocate.deleteSign"));


                        deleteBtnText.position(
                            item.x + 50,
                            -item.y + 190 + heightImg - hRect + (isPhone ? 55 : 0),
                            "relative "
                        );

                        deleteLocket.position(
                            item.x + 17,
                            -item.y + 153 + heightImg - hRect + (isPhone ? 55 : 0),
                            "relative "
                        );

                        deletesignBtn.position(
                            item.x + 161,
                            -item.y + 153 + heightImg - hRect + (isPhone ? 55 : 0),
                            "relative "
                        );

                        deleteLocket.class("canvasBtnSignLocket")
                        deletesignBtn.class("canvasBtnSignCoordinates canvasBtnTrash");
                        deleteBtnText.class("canvasBtnDeleteText")
                        deletesignBtn.mouseClicked(() => {
                            const filteredSigns = signatures.filter(item => item.email === email)
                            const indexInTheirCoordinates = filteredSigns.findIndex(item => (item.x === signatures[i].x) && (item.y === signatures[i].y) && (item.page === signatures[i].page))
                            deleteSign(indexInTheirCoordinates, i);
                        });
                    }
                }
            }
            cancelBtn = sketch.createButton(t("button.accept"));
            signBtn = sketch.createImg(padlickUnlocket)
            locateBtnText = sketch.createButton(tFunction("signatureRequestProfile.dialogLocate.locateSign"))

            if (widthImg < 550) {
                cancelBtn.position(
                    widthImg / 2 - 47.5 + 16 + 95 + 50 + 50,
                    heightImg + 100 + (isPhone ? 200 : 100)
                );
            } else {
                cancelBtn.position(
                    widthImg / 2 - 47.5 + 35 + 300,
                    heightImg + 70 - 13 + (100)
                );
            }

            signBtn.position(
                xRect + 17,
                yRect + 151 + (isPhone ? 55 : 0)
            );

            locateBtnText.position(
                xRect + 60,
                yRect + 190 + (isPhone ? 55 : 0)
            );

            signBtn.class("canvasBtnSignCoordinates canvasBtnLocket");
            locateBtnText.class("canvasBtnSignText")
            cancelBtn.class("canvasBtn");

            signBtn.mouseClicked(() => {
                let data = {
                    x: xRect,
                    y: yRect,
                    width: wRect,
                    height: hRect,
                    savePostion,
                };
                data.y = heightImg - data.y - data.height;
                saveCoordinates(data);
                saveAndReload(data);
            });

            cancelBtn.mouseClicked(() => {
                back();
            });
        };
        sketch.draw = () => {
            let widthRect = wRect;
            let heightRect = hRect;
            let initX = xRect;
            let initY = yRect;
            sketch.background(220);
            sketch.fill("#005DA1");
            sketch.fill(255);
            sketch.image(page, 1, 2, widthImg - 2, heightImg - 2);

            if (
                sketch.mouseX >= initX + 5 &&
                sketch.mouseX <= initX + widthRect - 5 &&
                sketch.mouseY >= initY + 5 &&
                sketch.mouseY <= initY + heightRect - 5
            ) {
                sketch.cursor('grab')
                let isCurrent = false;
                isCurrent = overImage || isCurrent;
                if (!isCurrent && !done) overImage = true;
            } else {
                sketch.cursor('context-menu')
                overImage = false
            };

            // sketch.image(signature, initX, initY, widthRect, heightRect);
            if (validation.activeOnSubit) {
                isSubmit = true;
            }
            if (validation.activeOnSubit && isSubmit) {
                isSubmit = false;
            }
            const squareColor = sketch.color("#BBDEFB");
            squareColor.setAlpha(100);
            sketch.fill(squareColor);
            sketch.stroke("#2196F3");
            setLineDash([5, 5]); //longer stitches
            sketch.rect(initX, initY, widthRect, heightRect);
            sketch.fill(255, 255, 255);
            sketch.stroke("#fff");
            sketch.rect(0, heightImg + 2, widthImg, 100);
            // sketch.fill(0, 0, 0);
            if (signatures) {
                for (let i = 0; i < signatures.length; i++) {
                    const item = signatures[i];
                    if (item.page === currentPage && item.email === email) {
                        const squareColor = sketch.color("#B2EBF2");
                        squareColor.setAlpha(100);
                        sketch.fill(squareColor);
                        sketch.stroke("#00BCD4");
                        setLineDash([0]); //long line
                        sketch.rect(item.x, heightImg - item.y - item.height, wRect, hRect);
                    }
                }
            }
            if (isAndroid) {
                sketch.image(
                    isLock ? lockImg : unlockImg,
                    initX + widthRect * 0.9 - 13,
                    initY + 5,
                    26,
                    26
                );
            }
        };

        sketch.mousePressed = () => {
            if (
                sketch.mouseX >= xRect + 5 &&
                sketch.mouseX <= xRect + wRect - 5 &&
                sketch.mouseY >= yRect + 5 &&
                sketch.mouseY <= yRect + hRect - 5
            ) {
                sketch.cursor('grabbing')
            }
            if (isAndroid) {
                if (
                    xRect + wRect * 0.9 - 13 <= sketch.mouseX &&
                    xRect + wRect * 0.9 + 13 >= sketch.mouseX &&
                    yRect + 44 >= sketch.mouseY &&
                    yRect + 5 <= sketch.mouseY
                ) {
                    isLock = !isLock;
                } else if (!isLock) {
                    xRect = sketch.mouseX - wRect / 2;
                    yRect = sketch.mouseY - hRect / 2;
                }
            } else {
                if (overImage) {
                    locked = true;
                } else {
                    locked = false;
                }
                xOffSet = sketch.mouseX - xRect;
                yOffSet = sketch.mouseY - yRect;
            }
        };

        sketch.mouseDragged = () => {
            if (locked) {
                xRect = sketch.mouseX - Math.floor(xOffSet);
                yRect = sketch.mouseY - Math.floor(yOffSet);

                if (xRect >= widthImg) {
                    xRect = widthImg;
                }

                if (yRect >= heightImg) {
                    yRect = heightImg;
                }

                locateBtnText.position(
                    xRect + 60,
                    yRect + 190 + (isPhone ? 55 : 0)
                );

                signBtn.position(
                    xRect + 17,
                    yRect + 151 + (isPhone ? 55 : 0)
                );
            }
        };

        sketch.mouseReleased = () => {
            locked = false;

            xRect = sketch.mouseX - Math.floor(xOffSet);
            yRect = sketch.mouseY - Math.floor(yOffSet);

            if (xRect >= (widthImg + wRect)) {
                xRect = widthImg;
            }

            if (yRect >= (heightImg + hRect)) {
                yRect = heightImg;
            }

            // if (xRect <= (widthImg - wRect)) {
            //     xRect = widthImg - wRect;
            // }
            // if (yRect <= (heightImg - hRect)) {
            //     yRect = heightImg - hRect;
            // }
        };
    };

    useEffect(() => {
        setp5Canvas(new p5(Sketch, p5Ref.current));
        setTimeout(() => {
            // gotToEnd();
        }, 100);
    }, [])

    return <div className="p5Container" ref={p5Ref} />;
}